<template>
  <router-view></router-view>
</template>

<style>
</style>

<script>
  export default {
    data() {
      return {
        role: window.localStorage.getItem('role'),
      }
    },
    created() {
      this.setInterceptor()
    },
    methods: {
      //响应拦截器 => 无权限跳转
      setInterceptor() {
        this.$http.interceptors.response.use(
          response => {
            if(response.data.result_code === 403) {
              //没有权限-》跳转
              if(window.localStorage.role=='admin'){
                this.$router.push({name: 'adminLogin'})
              }
              if(window.localStorage.role=='factory'){
                this.$router.push({name: 'factoryLogin'})
              }
              //请求不成功-》error message
              return Promise.reject('请先登录')
              // this.$message.error("请先登录")
            }
            //将response体传递给then
            return response
          },
          error => {
            //error message
            this.$message.error(error.toString())
            return Promise.reject(error)
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue